export default class System {
  constructor(system, molten) {
    this.model = system;
    this.molten = molten;
    this.uiName = molten.getConfig('uiName');
  }
  get id() {
    return this.model.id;
  }
  get metadata() {
    return (this.model.metadata?.mutations ? this.model.metadata.mutations[this.uiName]?.metadata : this.model.metadata) || {};
  }

  /**
   * Returns the tags in the model
   */
  get tags() {
    return (this.model.metadata?.mutations ? this.model.metadata.mutations[this.uiName]?.tags : this.model.tags) || [];
  }

  /**
   * Returns true if the tags include the specified tab
   */
  hasTag(tag) {
    return this.tags.includes(tag);
  }

  /**
   * Returns the first tag starting with the prefix
   * If strip is true, this will return the value of the 
   * tag after the prefix
   */
  getTagStartingWith(prefix, strip) {
    const arr = this.tags;
    if (arr == null) {
      return null;
    }
    const val = arr.find(t => t.startsWith(prefix));
    if (val && strip) {
      return val.substring(prefix.length);
    }
    return val;
  }

  /**
   * Returns all tags starting with the prefix
   * If strip is true, this will return the value of the 
   * tag after the prefix
   */
  getTagsStartingWith(prefix, strip) {
    let arr = this.tags;
    if (arr == null) {
      return [];
    }
    arr = arr.filter(t => t.startsWith(prefix));
    if (arr.length > 0 && strip) {
      return arr.map(val => val.substring(prefix.length));
    }
    return arr;
  }
}